(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["welcome-offer-popup"] && !Shopify.designMode) return;
  try {
    (function(){
      var popup=document.getElementById('XixipupWelcomeOffer');if(!popup)return;
      var key='xixipup_welcome_offer_dismissed_at',week=7*24*60*60*1000;
      var delay=Number(popup.dataset.offerDelay||12000);
      try{var dismissed=Number(localStorage.getItem(key)||0);if(Date.now()-dismissed<week)return;}catch(e){}
      function close(){popup.classList.remove('is-open');popup.setAttribute('aria-hidden','true');try{localStorage.setItem(key,String(Date.now()));}catch(e){}}
      window.setTimeout(function(){popup.classList.add('is-open');popup.setAttribute('aria-hidden','false');},delay);
      popup.querySelectorAll('[data-offer-close]').forEach(function(el){el.addEventListener('click',close);});
      popup.querySelector('[data-offer-shop]').addEventListener('click',close);
      popup.querySelector('[data-offer-copy]').addEventListener('click',function(){
        var button=this,code='HELLOXIXI';
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(code);}
        button.querySelector('small').textContent='Copied';
        window.setTimeout(function(){button.querySelector('small').textContent='Copy code';},1800);
      });
      document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    })();
  } catch(e) { console.error(e); }
})();

})();
